import axios from 'axios'

const API_URL = process.env.REACT_APP_API_URL || 'https://dev.api.eyeconx.com/v1/public/';

let axiosConfig = {
    headers: {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin':'*',
    }
  };
const getClinicByShortCode=(shortcode)=>{
    return axios.get(API_URL+"reputation/"+encodeURIComponent(shortcode),axiosConfig);
}

const addComment = (id,data)=>{
    return axios.post(API_URL+"reputation/"+id+"/comments",data);
}

const getLinks = (id)=>{
    return axios.get(API_URL+"reputation/"+id+"/links");
}
const addFeedback = (id,data)=>{
    return axios.post(API_URL+"reputation/"+id+"/feedback",data);
}
const getPatientPref = (clinicId,patientId,uuid,type,data)=>{
    return axios.get(API_URL+"clinics/"+clinicId+"/patients/"+patientId+"/welcome/"+uuid+"?type="+type+"&data="+data)
}
const getHours =(clinicId)=>{
    return axios.get(API_URL+"clinics/"+clinicId+"/clinic-hours")
}
const updatePatientPref = (clinicId,patientId,uuid,type,data,prefValue)=>{
    return axios.put(API_URL+"clinics/"+clinicId+"/patients/"+patientId+"/preferences/"+uuid+"?type="+type+"&data="+data,prefValue)
}
const clorder = (clinicid,data)=>{
    return axios.post(API_URL+"clinics/"+clinicid+"/cl-orders",data)
}
const getPatientCommPreferences = (clinicId, patientId) => {
    return axios.get(API_URL+"clinics/"+clinicId+"/patients/"+patientId+"/comm-preferences")
}
const updatePatientCommPreferences = (clinicId, patientId, payload) => {
    return axios.put(
        API_URL + "clinics/" + clinicId + "/patients/" + patientId + "/comm-preferences",
        payload,
        axiosConfig
    )
}
/** GET /v1/public/clinics/{clinicId}/patients/{patientId}/unsubscribe */
const unsubscribe = (clinicId, patientId, type, data) => {
    const params = new URLSearchParams();
    if (type) params.set('type', type);
    if (data) params.set('data', data);
    const query = params.toString();
    return axios.get(
        API_URL + "clinics/" + clinicId + "/patients/" + patientId + "/unsubscribe" +
        (query ? "?" + query : "")
    );
};
const getArticle = (clinicId, articleId) => {
    return axios.get(API_URL + "clinics/" + clinicId + "/articles/" + articleId)
}
/** POST /v1/public/gateway/sms-confirmation (EyeconX-API) */
const getGatewayClinicInfo = (clinicId, messageId) => {
    const formData = new FormData();
    formData.append("clinicId", clinicId);
    formData.append("messageId", messageId);
    return axios.post(API_URL + "gateway/sms-confirmation", formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
            'Access-Control-Allow-Origin': '*',
        }
    })
}
const getClinicTheme = (clinicId) => {
    return axios.get(API_URL + "clinics/" + clinicId + "/theme")
}
const getClBrands = (clinicId) => {
    return axios.get(API_URL+"clinics/"+clinicId+"/cl-brands")
}
const getBookingTypes = (clinicId) => {
    return axios.get(API_URL+"clinics/"+clinicId+"/booking/appointment-types")
}
const getVisitReasons = (clinicId) => {
    return axios.get(API_URL+"clinics/"+clinicId+"/booking/visit-reasons")
}
const getBookingDoctors = (clinicId, apptTypeId, date) => {
    const query = date ? "?date="+date : "";
    return axios.get(API_URL+"clinics/"+clinicId+"/booking/appointment-types/"+apptTypeId+"/doctors"+query)
}
const getAvailableSlots = (clinicId, apptTypeId, doctorId, date) => {
    return axios.get(API_URL+"clinics/"+clinicId+"/booking/appointment-types/"+apptTypeId+"/doctors/"+doctorId+"/slots?date="+date)
}
const createAppointmentRequest = (clinicId, payload) => {
    return axios.post(API_URL+"clinics/"+clinicId+"/booking/appointment-requests", payload, axiosConfig)
}
/** POST /v1/public/clinics/{clinicId}/appointments/{appointmentId}/confirm */
const confirmAppointment = (clinicId, appointmentId) => {
    return axios.post(
        API_URL + "clinics/" + clinicId + "/appointments/" + appointmentId + "/confirm",
        null,
        axiosConfig
    )
}
/** POST /v1/public/clinics/{clinicId}/appointments/{appointmentId}/decline */
const declineAppointment = (clinicId, appointmentId) => {
    return axios.post(
        API_URL + "clinics/" + clinicId + "/appointments/" + appointmentId + "/decline",
        null,
        axiosConfig
    )
}
/** GET /v1/public/clinics/{clinicId}/surveys/{surveyId}/patient/{patientId} */
const getPatientSurvey = (clinicId, surveyId, patientId) => {
    return axios.get(
        API_URL + "clinics/" + clinicId + "/surveys/" + surveyId + "/patient/" + patientId
    )
}
/** POST /v1/public/clinics/{clinicId}/surveys/{surveyId}/patient/{patientId} */
const submitPatientSurvey = (clinicId, surveyId, patientId, payload) => {
    return axios.post(
        API_URL + "clinics/" + clinicId + "/surveys/" + surveyId + "/patient/" + patientId,
        payload,
        axiosConfig
    )
}
const clinicService = {
    getClinicByShortCode,
    addComment,
    getLinks,
    addFeedback,
    getPatientPref,
    getHours,
    updatePatientPref,
    clorder,
    unsubscribe,
    getArticle,
    getGatewayClinicInfo,
    getClinicTheme,
    getPatientCommPreferences,
    updatePatientCommPreferences,
    getClBrands,
    getBookingTypes,
    getVisitReasons,
    getBookingDoctors,
    getAvailableSlots,
    createAppointmentRequest,
    confirmAppointment,
    declineAppointment,
    getPatientSurvey,
    submitPatientSurvey
}
export default clinicService